export default __webpack_public_path__ + "static/media/cached-24px.13c23ee2.svg";